import { Box, Button, TextField, styled } from '@mui/material';

import { COLORS } from '../../../../../../configs/colors';

export const NoteContent = styled(Box)({
  padding: 16,
});

export const InputWrapper = styled(Box)({
  position: 'relative',
  marginBottom: 16,
});

export const NotesTextField = styled(TextField)`
  .MuiOutlinedInput-root {
    border-radius: 8px;
    font-size: 14px;
  }

  .MuiInputBase-input {
    padding: 12px;
  }
`;

export const CharacterCount = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isNearLimit',
})<{ isNearLimit: boolean }>`
  position: absolute;
  bottom: 8px;
  right: 12px;
  font-size: 11px;
  color: ${({ isNearLimit }) => (isNearLimit ? COLORS.Orange : COLORS.Gray)};
`;

export const ErrorMessage = styled(Box)`
  padding: 12px 16px;
  background-color: ${COLORS.LightRedBackground};
  color: ${COLORS.DarkRed};
  border-radius: 8px;
  margin-bottom: 16px;
  font-size: 14px;
`;

export const SubmitButton = styled(Button)`
  text-transform: none;
  font-size: 14px;
  font-weight: 600;
  padding: 12px;
  border-radius: 8px;
  background-color: ${COLORS.NavyBlue};

  &:hover {
    background-color: ${COLORS.LightNavyBlue};
  }
`;

export const CancelButton = styled(Button)`
  text-transform: none;
  font-size: 14px;
  font-weight: 500;
  padding: 12px;
  border-radius: 8px;
`;
